<template>
  <div class="relative block">
    <button
      @click="toggleMenu"
      class="grey-shadow border-solid border-2 rounded-xl border-white py-1 pr-3 pl-5 cursor-pointer"
      role="combobox"
      v-click-outside="closeMenu"
    >
      <div class="flex flex-wrap justify-center">
        <span>Account Settings</span>
        <svg class="w-6 h-6 ml-2" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
          <path v-if="isOpen" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path>
          <path v-if="!isOpen" d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
        </svg>
      </div>
    </button>
    <div
      v-if="isOpen"
      class="absolute mt-2 border-solid border-2 border-[#0000001a] bg-white mr-[-3px] w-max right-0 z-50"
    >
      <div class="grid grid-cols-1 divide-y-2">
        <MenuItem title="Manage Subscription" href="/my-subscriptions" />
        <MenuItem title="Change password" href="/change-password" />
        <MenuItem title="Log out" href="/logout" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import MenuItem from "./MenuItem.vue";
import "./../../Utils/Directives";

export default Vue.extend({
  components: {
    MenuItem,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
  },
});
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss" scoped>
@import "@theme/Main.scss";
</style>
